import { render, staticRenderFns } from "./Ecologicaldata.vue?vue&type=template&id=151e31d2&"
import script from "./Ecologicaldata.vue?vue&type=script&lang=js&"
export * from "./Ecologicaldata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports